import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import DragAndResize from "../../components/DragAndResize";
import ContentScheduler from "../../components/ContentScheduler";
import DirectoryViewComponent from "../../components/views/DirectoryViewComponent";
import {
  Button,
  Col,
  Popover,
  Radio,
  Row,
  Space,
  Modal,
  Switch,
  Alert,
  Badge,
} from "antd";
import ScreenTableView from "../../components/views/ScreenTableView";
import Data from "../../data/data";
import WeekdayScheduler from "../../components/WeekdayScheduler";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
} from "../../actions";
import TimelineListElement from "../../components/TimelineListElement";
import PopupManager from "../../managers/PopupManager";
import { Container, Draggable } from "react-smooth-dnd";
import { applyDrag } from "../../utils/DragUtils";
import {
  CloudUploadOutlined,
  PlayCircleOutlined,
  PartitionOutlined,
  DesktopOutlined,
} from "@ant-design/icons";
import CalendarView from "../../components/views/CalendarView";
import PermissionManager from "../../managers/PermissionManager";
import ScreenPreviewPopup from "../../components/popups/ScreenPreviewPopup";
import {
  preparePlaylists,
  prepareTimelineElements,
} from "../../helpers/ContentJsonHelper";
import TimelineElementSchduleGeneratorPopup from "../../components/popups/TimelineElementSchduleGeneratorPopup";
import DataHelper from "../../helpers/DataHelper";
import { THEME_PALLETE } from "../../Theme";
import {
  Layers,
  Plus,
  Upload,
  Play,
  LayoutList,
  Calendar,
  Monitor,
  AlertTriangle,
} from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

// import
class TimelinePage extends Component {
  constructor(props) {
    super(props);
    this.screenPreviewPopupRef = React.createRef();
    this.createTimelineElementSchedulePopupRef = React.createRef();
    this.state = {
      attachedScreens: [],
      timelineDatas: [],
      viewMode: "timeline",
      eventDatas: [],
      campaignsync: false,
    };
  }

  componentDidMount() {
    this.updateTimelineListData();
    this.reloadAttachedScreens();
  }

  updateTimelineListData = () => {
    const { requestServerGet, userdata, selectedBrandData, selectedCampaign } =
      this.props;

    if (!selectedBrandData) return;

    if (!selectedCampaign) return;

    // const colors = ["#A70267", "#F10C49", "#FB6B41", "#F6D86B", "#339194"]
    // const colors = ["#fc5c65", "#fd9644", "#fed330", "#2bcbba", "#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#eb3b5a", "#fa8231", "#f7b731", "#20bf6b", "#0fb9b1", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    const colors = [
      "#C78283",
      "#26547C",
      "#32936F",
      "#FFE066",
      "#0E6BA8",
      "#60D394",
      "#F3722C",
      "#0EAD69",
      "#277DA1",
      "#F94144",
    ];
    // const colors = ["#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    requestServerGet(
      "get_timelines",
      {
        brandid: selectedBrandData.BrandID,
        campaignid: selectedCampaign.CampaignID,
      },
      null,
      (response) => {
        // console.log(JSON.stringify(response.data))
        this.setState({
          timelineDatas: response.data
            .sort((a, b) => {
              return a.Ordering - b.Ordering;
            })
            .map((tl, index) => {
              tl.color = tl.Color
                ? tl.Color
                : colors[parseInt(tl.TimelineID) % colors.length];
              return tl;
            }),
        });
        this.reloadAttachedScreens();
      },
      userdata.token,
    );
  };

  reloadAttachedScreens = () => {
    const { selectedBrandData, selectedBranchData, selectedCampaign } =
      this.props;

    DataHelper.getScreens(
      {
        brandid: selectedBrandData.BrandID,
        branchid: selectedBranchData ? selectedBranchData.BranchID : undefined,
      },
      this.props,
    ).then((data) => {
      const filteredScreens = data.filter(
        (screen) => screen.CampaignID === selectedCampaign.CampaignID,
      );
      this.setState({ attachedScreens: filteredScreens });
    });
  };

  updateEventTimelineListData = () => {
    const { requestServerGet, userdata, selectedBrandData, selectedCampaign } =
      this.props;

    if (!selectedBrandData) return;

    if (!selectedCampaign) return;

    // const colors = ["#A70267", "#F10C49", "#FB6B41", "#F6D86B", "#339194"]
    // const colors = ["#fc5c65", "#fd9644", "#fed330", "#2bcbba", "#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#eb3b5a", "#fa8231", "#f7b731", "#20bf6b", "#0fb9b1", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    const colors = [
      "#C78283",
      "#26547C",
      "#32936F",
      "#FFE066",
      "#0E6BA8",
      "#60D394",
      "#F3722C",
      "#0EAD69",
      "#277DA1",
      "#F94144",
    ];
    // const colors = ["#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    requestServerGet(
      "get_events",
      {
        brandid: selectedBrandData.BrandID,
        campaignid: selectedCampaign.CampaignID,
      },
      null,
      (response) => {
        // console.log(JSON.stringify(response.data))
        this.setState({
          eventDatas: response.data
            .sort((a, b) => {
              return a.Ordering - b.Ordering;
            })
            .map((tl, index) => {
              tl.color = tl.Color
                ? tl.Color
                : colors[parseInt(tl.TimelineID) % colors.length];
              return tl;
            }),
        });
        this.reloadAttachedScreens();
      },
      userdata.token,
    );
  };

  onEditTimelineClicked = (timelineID) => {
    const timelineData = this.state.timelineDatas.find((tl) => {
      return tl.TimelineID === timelineID;
    });

    if (timelineData) this.launchEditTimeline(timelineData);
  };

  onDelteTimelineClicked = (timelineID) => {
    const { requestServerPost, userdata } = this.props;

    requestServerPost(
      "delete_timeline",
      { timelineid: timelineID },
      null,
      (response) => {
        // console.log(JSON.stringify(response.data))
        this.updateTimelineListData();
      },
      userdata.token,
    );
  };
  onDuplicateTimelineClicked = (timelineID) => {
    const timelineData = this.state.timelineDatas.find((tl) => {
      return tl.TimelineID === timelineID;
    });

    if (timelineData) this.launchDuplicateTimeline(timelineData);
  };

  onTimelnieSelected = (timelineData) => {
    const { onTimelineSelected = () => {} } = this.props;
    if (onTimelineSelected) {
      onTimelineSelected(timelineData);
    }
  };

  renderTimelilneItem = (data, index) => {
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );

    return (
      <TimelineListElement
        onTimelineUpdated={this.updateTimelineListData}
        allowEdit={editPermission}
        allowDelete={editPermission}
        onClick={() => {
          this.onTimelnieSelected(data);
        }}
        onEdit={this.onEditTimelineClicked}
        onDelete={this.onDelteTimelineClicked}
        onDuplicate={this.onDuplicateTimelineClicked}
        data={data}
        index={index}
      ></TimelineListElement>
    );
  };

  renderEventItem = (data, index) => {
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );

    return (
      <TimelineListElement
        onTimelineUpdated={this.updateTimelineListData}
        allowEdit={editPermission}
        allowDelete={editPermission}
        onClick={() => {
          this.onTimelnieSelected(data);
        }}
        onEdit={this.onEditTimelineClicked}
        onDelete={this.onDelteTimelineClicked}
        data={data}
        index={index}
      ></TimelineListElement>
    );
  };

  renderCalendarView = () => {
    return <CalendarView datas={this.state.timelineDatas}></CalendarView>;
  };

  renderTimelineList = () => {
    if (this.state.timelineDatas.length === 0) return null;

    const { selectedBrandData, globalSearch = "aloha" } = this.props;

    return this.state.timelineDatas
      .filter((data) => {
        return globalSearch
          ? data.TimelineName.toLocaleLowerCase().includes(
              globalSearch.toLocaleLowerCase(),
            )
          : true;
      })
      .map((data, index) => {
        return (
          <Draggable key={data.TimelineID}>
            {/* <Col span={24}> */}
            {/* <motion.div style={{ width: "100%", display: "block" }} animate={{ scale: 0.96 }} whileHover={{ scale: 1, transition: { duration: 0.1 } }}> */}
            {/* <div style={{ width: "100%", display: "block" }}> */}
            <div className="draggable-item">
              {this.renderTimelilneItem(data, index)}
              {/* </div> */}
              {/* </Col > */}
            </div>
          </Draggable>
        );
      });
  };

  renderEventTimeline = () => {
    console.log(JSON.stringify(this.state.timelineDatas));
    if (this.state.eventDatas.length === 0) return null;

    const { selectedBrandData, globalSearch = "aloha" } = this.props;

    return this.state.eventDatas.map((data, index) => {
      return (
        <Draggable key={data.TimelineID}>
          {/* <Col span={24}> */}
          {/* <motion.div style={{ width: "100%", display: "block" }} animate={{ scale: 0.96 }} whileHover={{ scale: 1, transition: { duration: 0.1 } }}> */}
          {/* <div style={{ width: "100%", display: "block" }}> */}
          <div className="draggable-item">
            {this.renderEventItem(data, index)}
            {/* </div> */}
            {/* </Col > */}
          </div>
        </Draggable>
      );
    });
  };

  launchAssignAndPublish = (campaignData) => {
    const { selectedCampaign } = this.props;
    PopupManager.launchAssignAndPublishPopup(
      campaignData,
      this.reloadAttachedScreens,
    );
  };
  launchDuplicateTimeline = (timelineData) => {
    const { selectedCampaign } = this.props;
    PopupManager.launchDuplicateTimelinePopup(
      timelineData,
      selectedCampaign,
      this.updateTimelineListData,
    );
  };
  launchCreateTimeline = () => {
    const { selectedCampaign } = this.props;
    // console.log("launchCreateTimeline " + JSON.stringify(selectedCampaign))
    PopupManager.launchCreateTimelinePopup(
      selectedCampaign,
      this.updateTimelineListData,
    );
  };

  launchCreateEventTimeline = () => {
    const { selectedCampaign } = this.props;
    PopupManager.launchCreateEventTimelinePopup(
      selectedCampaign,
      this.updateEventTimelineListData,
    );
  };

  launchEditTimeline = (timelineData) => {
    const { selectedCampaign } = this.props;
    PopupManager.launchEditTimelinePopup(
      timelineData,
      selectedCampaign,
      this.updateTimelineListData,
    );
  };

  onTimelineItemReordered = (dragResult) => {
    const { requestServerPost, userdata, selectedCampaign } = this.props;

    // console.log("onTimelineItemReordered " + JSON.stringify(dragResult))

    const newArray = applyDrag(this.state.timelineDatas, dragResult);
    const orderings = newArray
      .map((tl) => {
        return tl.TimelineID;
      })
      .reduce((v1, v2) => `${v1},${v2}`);

    requestServerPost(
      "update_ordering",
      {
        target: "timelines",
        values: orderings,
        parentid: selectedCampaign.CampaignID,
      },
      null,
      (response) => {
        this.updateTimelineListData();
      },
      userdata.token,
    );

    this.setState({ timelineDatas: newArray });
  };

  onViewModeChange = (e) => {
    this.setState({ viewMode: e.target.value });
  };

  renderCampaignContent = () => {
    switch (this.state.viewMode) {
      case "timeline":
        return this.renderTimelineList();
        break;
      case "calendar":
        return this.renderCalendarView();
        break;
      default:
        return this.renderTimelineList();
        break;
    }
  };

  updateCampaignSync = (newSync) => {
    const { usertoken, selectedCampaign, requestServerPost } = this.props;
    var params = new FormData();

    console.log("[updateCampaignSync] " + selectedCampaign);

    if (selectedCampaign) {
      params.append("campaignid", selectedCampaign.CampaignID);
      params.append("campaignsync", newSync);

      requestServerPost(
        "update_campaign",
        params,
        {},
        (response) => {
          this.setState({ campaignsync: newSync });
        },
        usertoken,
      );
    }
  };

  onPreviewClick = () => {
    if (this.screenPreviewPopupRef.current) {
      const {
        usertoken,
        requestServerGet,
        selectedBrandData,
        selectedCampaign,
      } = this.props;

      requestServerGet(
        "preview_content",
        { campaignid: selectedCampaign.CampaignID },
        null,
        (response) => {
          // const options = response.data.map(data => {
          //     return { value: data.CampaignID, label: data.CampaignName }
          // })

          // console.log("preview_content " + JSON.stringify(response.data))
          const contentJSON = response.data;

          prepareTimelineElements(contentJSON.campaign);
          preparePlaylists(contentJSON.playlists, true);

          this.screenPreviewPopupRef.current.previewContent(contentJSON);
          // options.unshift({ value: 0, label: "Create New Playlist" })
          // this.setState({ campaigntDatas: options, campaignOptions: options })
        },
        usertoken,
      );

      // this.screenPreviewPopupRef.current.previewContent(data);
    }
  };

  render() {
    const t = this.props.langT || PRO_TRANSLATIONS.en.timelinePage;

    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const allowPublishPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_PUBLISH,
    );
    const allowAssignScreenPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_ASSIGNSCREEN,
    );

    const {
      onBackClicked = () => {},
      preventDefaultStepBack = false,
      selectedCampaign,
      localStepBack = () => {},
    } = this.props;

    const publishTitles = [];
    if (allowPublishPermission) {
      publishTitles.push(t.assignToScreens);
      publishTitles.push(t.publish);
    }
    const publishTitleString = publishTitles.join(" / ");

    const pendingScreens = this.state.attachedScreens.filter(
      (s) => s.PendingPublished === 1,
    );
    const totalScreens = this.state.attachedScreens.length;
    const campaignColor =
      selectedCampaign && selectedCampaign.CampaignColor
        ? selectedCampaign.CampaignColor
        : "#6366f1";

    return (
      <MainLayout
        style={{ padding: 20 }}
        renderBreadCrumb={() => {
          return [
            <span
              onClick={() => { localStepBack("campaign"); }}
              style={{ fontSize: 14, fontWeight: 600, color: "#64748b", padding: "4px 8px", lineHeight: "22px", cursor: "pointer" }}
            >
              {t.breadcrumbTitle}
            </span>,
            selectedCampaign
              ? [
                  "/",
                  <span
                    style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}
                  >
                    {selectedCampaign.CampaignName}
                  </span>,
                ]
              : null,
          ];
        }}
        onBackClicked={onBackClicked}
        preventDefaultStepBack={preventDefaultStepBack}
        id={Constants.CAMPAIGN_PAGE}
      >
        {/* Pending publish alert */}
        {pendingScreens.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: "#fffbeb",
              border: "1px solid #fcd34d",
              borderRadius: 12,
              padding: "12px 18px",
              marginBottom: 16,
              color: "#92400e",
            }}
          >
            <AlertTriangle
              size={16}
              color="#d97706"
              style={{ flexShrink: 0 }}
            />
            <span style={{ fontSize: 13, fontWeight: 500 }}>
              <strong>{pendingScreens.length}</strong> {t.pendingOf}{" "}
              <strong>{totalScreens}</strong> {t.pendingText}
            </span>
          </div>
        )}

        {/* Page header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            background: "#fff",
            borderRadius: 16,
            padding: "20px 24px",
            border: "1px solid #e8ecf3",
            marginBottom: 20,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                background: campaignColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Layers size={26} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", lineHeight: 1.2 }}>
                {selectedCampaign ? selectedCampaign.CampaignName : "Campaign"}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                {this.state.timelineDatas.length}{" "}
                {this.state.timelineDatas.length !== 1
                  ? t.timelinePlural
                  : t.timelineSingular}
                {totalScreens > 0
                  ? ` · ${totalScreens} ${totalScreens !== 1 ? t.screenPlural : t.screenSingular} ${t.attached}`
                  : ""}
              </div>
            </div>
          </div>

          {/* Action buttons */}
          {editPermission && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              {allowPublishPermission && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  {pendingScreens.length > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: -6,
                        right: -6,
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        background: "#f97316",
                        color: "#fff",
                        fontSize: 10,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                      }}
                    >
                      {pendingScreens.length}
                    </span>
                  )}
                  <button
                    onClick={() =>
                      this.launchAssignAndPublish(selectedCampaign)
                    }
                    style={{
                      height: 38,
                      padding: "0 16px",
                      borderRadius: 8,
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      color: "#334155",
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Upload size={14} /> {publishTitleString}
                  </button>
                </div>
              )}
              <button
                onClick={this.onPreviewClick}
                style={{
                  height: 38,
                  padding: "0 16px",
                  borderRadius: 8,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  color: "#334155",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                }}
              >
                <Play size={14} /> {t.preview}
              </button>
              <button
                onClick={this.launchCreateTimeline}
                style={{
                  height: 38,
                  padding: "0 18px",
                  borderRadius: 8,
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  border: "none",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                }}
              >
                <Plus size={15} color="#fff" /> {t.createTimeline}
              </button>
            </div>
          )}
        </div>

        {/* View toggle */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            background: "#f1f5f9",
            borderRadius: 10,
            padding: 4,
            marginBottom: 16,
            width: "fit-content",
          }}
        >
          {[
            {
              value: "timeline",
              label: t.timelineView,
              icon: <LayoutList size={14} />,
            },
            {
              value: "calendar",
              label: t.calendarView,
              icon: <Calendar size={14} />,
            },
          ].map((tab) => (
            <button
              key={tab.value}
              onClick={() => this.setState({ viewMode: tab.value })}
              style={{
                height: 34,
                padding: "0 16px",
                borderRadius: 7,
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                border: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                transition: "all 0.15s",
                ...(this.state.viewMode === tab.value
                  ? {
                      background: "#fff",
                      color: "#6366f1",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                    }
                  : { background: "transparent", color: "#64748b" }),
              }}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        {/* Timeline list */}
        <Container
          dragHandleSelector=".column-drag-handle"
          onDrop={this.onTimelineItemReordered}
        >
          {this.renderCampaignContent()}
        </Container>

        <ScreenPreviewPopup
          key="screen_preview"
          ref={this.screenPreviewPopupRef}
        />
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedTimelinePage = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(TimelinePage);

const TimelinePageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.timelinePage || PRO_TRANSLATIONS.en.timelinePage;
  return <ConnectedTimelinePage langT={t} {...props} />;
};

export default TimelinePageWithLang;
